import { Appearance } from './appearance';
import { Border } from './border';
import { Font } from './font';
import { Margin } from './margin';
import { Padding } from './padding';
import { Size } from './size';
var Component = /** @class */ (function () {
    function Component(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'id,visible,appearance,border,font,margin,padding,size';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                switch (key) {
                    case 'appearance':
                        _this[key] = new Appearance(obj[key]);
                        break;
                    case 'border':
                        _this[key] = new Border(obj[key]);
                        break;
                    case 'font':
                        _this[key] = new Font(obj[key]);
                        break;
                    case 'margin':
                        _this[key] = new Margin(obj[key]);
                        break;
                    case 'padding':
                        _this[key] = new Padding(obj[key]);
                        break;
                    case 'size':
                        _this[key] = new Size(obj[key]);
                        break;
                    default:
                        _this[key] = obj[key];
                        break;
                }
            }
        });
    }
    Component.prototype.toJSON = function () {
        var _this = this;
        var result = {
            "id": this.id,
            "type": "Component",
            "visible": this.visible,
            "appearance": null,
            "border": null,
            "font": null,
            "margin": null,
            "padding": null,
            "size": null,
        };
        var keys = 'appearance,border,font,margin,padding,size';
        keys.split(',').forEach(function (key) {
            if (_this[key]) {
                result[key] = _this[key].toJSON();
            }
        });
        return result;
    };
    Component.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Component;
}());
export { Component };
//# sourceMappingURL=component.js.map